export const HEALTH_CHECK = "health/check";
export const WARMUP_DB = "health/check-db";
